(() => {
  if (window.mangofyHeaderRefined) return;
  window.mangofyHeaderRefined = true;
  let trigger;
  const isMobile = () => matchMedia('(max-width: 1023px)').matches;
  document.addEventListener('click', event => {
    const opener = event.target.closest('modal-opener[data-id="#menu-drawer"]');
    if (opener) {
      trigger = opener;
      opener.setAttribute('aria-expanded', 'true');
      setTimeout(() => document.querySelector('#menu-drawer .close-menu')?.focus(), 200);
    } else if (event.target.closest('.close-menu') || event.target.id === 'menu-drawer') {
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }
  });
  document.addEventListener('keydown', event => {
    const opener = event.target.closest('modal-opener[role="button"]');
    if (opener && ['Enter', ' '].includes(event.key)) { event.preventDefault(); opener.click(); return; }
    const menu = document.querySelector('#menu-drawer');
    if (!isMobile() || !menu || menu.classList.contains('invisible')) return;
    if (event.key === 'Escape') {
      menu.hide?.(); trigger?.setAttribute('aria-expanded', 'false'); trigger?.focus();
    }
    if (event.key === 'Tab') {
      const controls = [...menu.querySelectorAll('a[href],button,[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
})();
